import { createFileRoute } from '@tanstack/react-router';
import { CategoryTable } from '@/components/Pages/Categories/CategoryTable';
import { CreateEditCategoryModal } from '@/components/Pages/Categories/CreateEditCategoryModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/categories')({
  component: CategoriesPage,
});

function CategoriesPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const showActions = isAdmin || isSuperAdmin;

  return (
    <Box>
      {showActions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditCategoryModal />
        </Box>
      )}
      <CategoryTable />
    </Box>
  );
}
